const buildQuery = (
  name,
  city,
  primaryCategories,
  address,
  state,
  postalCode,
  country,
  rawCategory,
  recordRecency,
  featureKeyword,
  description,
  requiredFields,
  reviews,
  menus,
  geoLocation,
  reviewsRangeQuery,
  reviewsByDate
) => {
  let queryParts = []
  if (name) {
    let nameQuery = `name:"${name}"`
    queryParts.push(nameQuery)
  }

  // Handling primaryCategories
  if (primaryCategories && primaryCategories.some(pt => pt !== 'Any')) {
    const filteredCategories = primaryCategories.filter(pt => pt !== 'Any')
    let categoriesQuery =
      filteredCategories.length > 1
        ? `primaryCategories:(${filteredCategories
            .map(pt => `"${pt}"`)
            .join(' OR ')})`
        : `primaryCategories:"${filteredCategories[0]}"`
    queryParts.push(categoriesQuery)
  }

  if (address) {
    queryParts.push(`address:"${address}"`)
  }
  if (city) {
    queryParts.push(`city:"${city}"`)
  }
  if (state) {
    queryParts.push(`province:"${state}"`)
  }
  if (postalCode) {
    queryParts.push(`postalCode:(${postalCode}*)`)
  }
  if (country) {
    queryParts.push(`country:"${country}"`)
  }

  if (rawCategory) {
    queryParts.push(`categories:"${rawCategory}"`)
  }

  // Handle recordRecency
  if (recordRecency) {
    const { dateAdded, dateUpdated } = recordRecency

    if (dateAdded) {
      const dateAddedQuery = `dateAdded:[${dateAdded} TO *]`
      queryParts.push(dateAddedQuery)
    }

    if (dateUpdated) {
      const dateUpdatedQuery = `dateUpdated:[${dateUpdated} TO *]`
      queryParts.push(dateUpdatedQuery)
    }
  }

  // Handling featureKeyword
  if (featureKeyword) {
    const { key, value } = featureKeyword

    if (key && value) {
      // Both key and value exist
      const featureKeywordQuery = `{features.key:"${key}" AND features.value:"${value}"}`
      queryParts.push(featureKeywordQuery)
    } else if (key) {
      // Only key exists
      const featureKeywordQuery = `features.key:"${key}"`
      queryParts.push(featureKeywordQuery)
    } else if (value) {
      // Only value exists
      const featureKeywordQuery = `features.value:"${value}"`
      queryParts.push(featureKeywordQuery)
    }
  }

  if (description?.value) {
    const descriptionQuery = `descriptions.value:"${description.value}"`
    queryParts.push(descriptionQuery)
  }

  if (requiredFields && requiredFields.length > 0) {
    requiredFields.forEach(field => {
      if (field === 'emailsAndPhonesException') {
        queryParts.push(`(emails:* OR phones:*)`)
      } else {
        queryParts.push(`${field}:*`)
      }
    })
  }

  if (reviews?.value) {
    const reviewsQuery = `reviews.rating:${reviews.value}`
    queryParts.push(reviewsQuery)
  }

  if (reviewsRangeQuery) {
    const { min, max } = reviewsRangeQuery
    if (min || max) {
      const minPart = min || '*'
      const maxPart = max || '*'
      const reviewsRangeQueryString = `reviews.rating:[${minPart} TO ${maxPart}]`
      queryParts.push(reviewsRangeQueryString)
    }
  }

  if (reviewsByDate) {
    const { start, end } = reviewsByDate
    if (start) {
      const toValue = end && end >= start ? end : '*'
      queryParts.push(`reviews.date:[${start} TO ${toValue}]`)
    }
  }

  if (menus?.value) {
    const menusQuery = `menus.description:"${menus.value}"`
    queryParts.push(menusQuery)
  }

  if (geoLocation?.value) {
    const geoLocationQuery = `geoLocation:[${geoLocation.value}]`
    queryParts.push(geoLocationQuery)
  }

  // Return the combined query or default if no parameters are set
  return queryParts.length > 0 ? queryParts.join(' AND ') : 'keys:*'
}

export default buildQuery
